/**
 * แปลงคำอ่านจาก KANJIDIC ให้เป็นคำที่อ่านออกทันที
 *
 * ต้นทางเขียนแบบย่อสำหรับพจนานุกรม ไม่ใช่สำหรับคนเพิ่งเริ่ม:
 *
 *   た.べる   จุดคือรอยต่อ — ก่อนจุดคือส่วนที่คันจิกิน หลังจุดคือ okurigana
 *   -び      ขีดนำหน้าคือรูปที่ใช้ต่อท้ายคำอื่น (三日 みっか) ไม่ใช่คำเดี่ยว
 *   ひと-     ขีดตามหลังคือรูปที่ใช้นำหน้าคำอื่น (一目 ひとめ)
 *
 * `た.べる` จึงต้องถอดรหัสในหัวก่อนใช้ ทั้งที่มันคือ 食べる (たべる) ซึ่งพูดได้เลย
 * ตัวที่มีขีดถูกตัดทิ้ง เพราะมันไม่ใช่คำ — ต้องมีคำอื่นมาต่อถึงจะใช้ได้
 */

export interface KunWord {
  /** รูปที่เขียนจริง — 食べる */
  word: string
  /** อ่านว่า — たべる */
  reading: string
}

/**
 * คำที่ใช้ได้จริงจากคำอ่าน kun ของคันจิตัวนี้
 *
 * เรียงตามต้นทาง (KANJIDIC เอาคำที่พบบ่อยขึ้นก่อน) และตัดคำซ้ำที่เขียนเหมือนกัน
 * — 水 มีทั้ง `みず` กับ `みず-` ซึ่งเขียนออกมาเป็น 水 เหมือนกันทั้งคู่
 *
 * เอาแค่สองคำ เพราะคำที่สามมักเป็นรูปที่แทบไม่เจอ (自ら · 自ずから · 自ずと)
 * และสามคำกินสามบรรทัดบนจอมือถือ
 */
export function kunWords(kanji: string, kun: readonly string[], limit = 2): KunWord[] {
  const out: KunWord[] = []
  const seen = new Set<string>()

  for (const raw of kun) {
    // รูปที่ต้องมีคำอื่นมาประกบ ไม่ใช่คำที่พูดเดี่ยวได้
    if (raw.startsWith('-') || raw.endsWith('-')) continue

    const dot = raw.indexOf('.')
    const reading = dot === -1 ? raw : raw.slice(0, dot) + raw.slice(dot + 1)
    const word = dot === -1 ? kanji : kanji + raw.slice(dot + 1)
    if (!reading || seen.has(word)) continue

    seen.add(word)
    out.push({ word, reading })
    if (out.length >= limit) break
  }
  return out
}
